import Error from '../model/Error';
import Money from '../dto/Money';
import axios from 'axios';

export default class ClubMemberCreditRepository {

    static getRemainingBalanceForSalesList(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/credits/sales-list`)
                .then(response => resolve(Money.fromData(response.data.data.remainingCredit.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
